<template>
    <!-- <AppLayout title="Profile"> -->
        <v-card>
            <v-tabs
            v-model="tab"
            bg-color="surface-dark"
            >
                <v-tab value="1">Typography</v-tab>
                <v-tab value="2">Borders</v-tab>
                <v-tab value="3">Palette</v-tab>
                <v-tab value="4">Buttons</v-tab>
            </v-tabs>

            <v-card-text>
                <v-tabs-window v-model="tab">
                    <v-tabs-window-item value="1">
                        <div class="d-flex ga-2 flex-column">
                            <template v-for="(fontSize, i1) in fontSizes" :key="i1">
                                <template v-for="(fontWeight, i2) in fontWeights" :key="i2">
                                    <template v-for="(textColor, i3) in textColors" :key="i3">
                                        <div :class="`text-${textColor} fs-${fontSize} fw-${fontWeight}`">(text-{{textColor}} | fs-{{fontSize}} | fw-{{fontWeight}}) :The quick brown fox jumps over the lazy dog</div>
                                    </template>
                                </template>
                                <v-divider class="py-3"></v-divider>
                            </template>
                        </div>
                    </v-tabs-window-item>
                        
                    <v-tabs-window-item value="2">
                        <div class="bg-background py-4">
                            <div :class="`border-b border-divider py-1`">( border-divider )</div>
                            <div :class="`border-b border-secondary py-1`">( border-secondary )</div>
                            <div :class="`border-b border-secondary-light py-1`">( border-secondary-light )</div>
                            <div :class="`border-b border-divider-light py-1`">( border-divider-light )</div>
                        </div>
                        <div class="bg-surface py-4">
                            <div :class="`border-b border-divider py-1`">( border-divider )</div>
                            <div :class="`border-b border-secondary py-1`">( border-secondary )</div>
                            <div :class="`border-b border-secondary-light py-1`">( border-secondary-light )</div>
                            <div :class="`border-b border-divider-light py-1`">( border-divider-light )</div>
                        </div>
                    </v-tabs-window-item>

                    <v-tabs-window-item value="3">
                        <div class="d-flex ga-0 flex-column">
                            <template v-for="(bgColor, index) in bgColorsArr" :key="index">
                                <div :class="`bg-${bgColor} py-2`">( bg-{{bgColor}} ) :The quick brown fox jumps over the lazy dog</div>
                            </template>
                        </div>
                    </v-tabs-window-item>
                    <v-tabs-window-item value="4">
                        <div class="d-flex ga-4 flex-column">
                            <div class="d-flex flex-wrap ga-0">
                                <v-btn-modal color="btn-secondary">Primary</v-btn-modal>
                                <v-btn-modal>Primary</v-btn-modal>
                                <v-btn-input-compact>Primary</v-btn-input-compact>
                                <v-btn>Primary</v-btn>
                                <v-btn-icon><mdi-icon>home</mdi-icon></v-btn-icon>
                                <v-btn-icon-outlined><mdi-icon>home</mdi-icon></v-btn-icon-outlined>
                                <v-btn-icon-text><mdi-icon>home</mdi-icon></v-btn-icon-text>
                                <v-btn-icon-pill><mdi-icon>home</mdi-icon></v-btn-icon-pill>
                                <v-btn-icon-text-pill><mdi-icon>home</mdi-icon></v-btn-icon-text-pill>
                                <v-btn-icon-outlined><mdi-icon>home</mdi-icon></v-btn-icon-outlined>
                                <v-btn-icon-outlined-pill><mdi-icon>home</mdi-icon></v-btn-icon-outlined-pill>
                                <v-btn-modal>Danger</v-btn-modal>
                            </div>
                            <div class="d-flex flex-wrap ga-4">
                                <v-btn>Primary</v-btn>
                                <v-btn>
                                    <template #prepend>
                                        <mdi-icon>home</mdi-icon>
                                    </template>
                                    Primary
                                </v-btn>
                            </div>
                            <div class="d-flex ga-2">
                                <div class="w-20rem">
                                    <v-text-field
                                        name="name"
                                        label="label"
                                        density="default"
                                    ></v-text-field>
                                </div>
                                <div>
                                    <v-btn-icon-outlined class="match-input" color="secondary-light"><mdi-icon>Home</mdi-icon></v-btn-icon-outlined>
                                </div>
                                <div>
                                    <v-btn-icon-outlined-pill class="match-input" color="secondary-light"><mdi-icon>Home</mdi-icon></v-btn-icon-outlined-pill>
                                </div>
                                <div>
                                    <v-btn-input icon color="secondary-light"><mdi-icon>Home</mdi-icon></v-btn-input>
                                </div>
                                <div>
                                    <v-btn-input color="secondary-light"><mdi-icon>Home</mdi-icon> Home</v-btn-input>
                                </div>
                                <div>
                                    <v-btn class="match-input" color="secondary"><mdi-icon>Home</mdi-icon> Primary</v-btn>
                                </div>
                                <div>
                                    <v-btn-icon class="match-input" color="btn-secondary"><mdi-icon>Home</mdi-icon></v-btn-icon>
                                </div>
                                <div>
                                    <v-btn-icon-pill class="match-input" color="secondary-light"><mdi-icon>Home</mdi-icon></v-btn-icon-pill>
                                </div>
                                <div>
                                    <v-btn-icon-text-pill class="match-input" color="secondary-light"><mdi-icon>Home</mdi-icon></v-btn-icon-text-pill>
                                </div>
                            </div>
                            <div class="d-flex ga-2">
                                <div class="w-20rem">
                                    <v-text-field
                                        name="name"
                                        label="label"
                                        density="comfortable"
                                    ></v-text-field>
                                </div>
                                <div>
                                    <v-btn-icon-outlined class="match-input-comfortable" color="secondary-light"><mdi-icon>Home</mdi-icon></v-btn-icon-outlined>
                                </div>
                                <div>
                                    <v-btn class="match-input-comfortable" color="secondary"><mdi-icon>Home</mdi-icon> Primary</v-btn>
                                </div>
                                <div>
                                    <v-btn-input-comfortable icon color="secondary-light"><mdi-icon>Home</mdi-icon></v-btn-input-comfortable>
                                </div>
                                <div>
                                    <v-btn-input-comfortable color="secondary-light"><mdi-icon>Home</mdi-icon> Home</v-btn-input-comfortable>
                                </div>
                            </div>
                            <div class="d-flex ga-2">
                                <div class="w-20rem">
                                    <v-text-field
                                        name="name"
                                        label="label"
                                        density="compact"
                                    ></v-text-field>
                                </div>
                                
                                <div>
                                    <v-btn class="match-input-compact" color="secondary"><mdi-icon>Home</mdi-icon> Primary</v-btn>
                                </div>
                                <div>
                                    <v-btn-icon-outlined class="match-input-compact" color="secondary-light"><mdi-icon>Home</mdi-icon></v-btn-icon-outlined>
                                </div>
                                <div>
                                    <v-btn-input-compact icon color="secondary-light"><mdi-icon>Home</mdi-icon></v-btn-input-compact>
                                </div>
                                <div>
                                    <v-btn-input-compact color="secondary-light"><mdi-icon>Home</mdi-icon> Home</v-btn-input-compact>
                                </div>
                            </div>
                            <div class="d-flex ga-2">
                                <div class="w-20rem">
                                    <v-text-field-v1
                                        name="name"
                                        label="label"
                                    ></v-text-field-v1>
                                </div>
                                
                                <div>
                                    <v-btn-v1 color="secondary"><mdi-icon>Home</mdi-icon> Primary</v-btn-v1>
                                </div>
                                
                                <div>
                                    <v-btn-v1 icon><mdi-icon>Home</mdi-icon></v-btn-v1>
                                </div>
                                <div>
                                    <v-btn-icon-outlined class="match-input-compact" color="secondary-light"><mdi-icon>Home</mdi-icon></v-btn-icon-outlined>
                                </div>
                                <div>
                                    <v-btn-input-compact icon color="secondary-light"><mdi-icon>Home</mdi-icon></v-btn-input-compact>
                                </div>
                                <div>
                                    <v-btn-input-compact color="secondary-light"><mdi-icon>Home</mdi-icon> Home</v-btn-input-compact>
                                </div>
                            </div>
                        </div>
                    </v-tabs-window-item>
                </v-tabs-window>
            </v-card-text>
        </v-card>
    <!-- </AppLayout> -->
</template>

<script setup lang="ts">
    import { ref } from 'vue';
    import AppLayout from '@/Layouts/AppLayout.vue';
    import { pageTitle } from '@/Composables/PageMeta';
    pageTitle.value = 'Theme';
    const tab = ref<any>(null);
    const fontSizes = `n5,n4,n3,n2,n1,1,2,3,4,5,6,7,8,9,10`.split(',');
    const fontWeights = `light,normal,medium,thick,bold`.split(',');
    const textColors = `base,secondary,secondary-light`.split(',');

    const bgColors = 'background,surface,surface-bright,surface-light,surface-dark,surface-variant,body,light,topbar,divider,divider-light,'+
                    'primary,primary-light,primary-dark,'+
                    'info,info-light,info-dark,'+
                    'secondary,secondary-light,'+
                    'success,success-light,'+
                    'warning,warning-light,'+
                    'danger,danger-light,'+
                    'error,error-light';
    const bgColorsArr = bgColors.split(',');
</script>